import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { StringConstants } from '@app/shared/string-constants';
import { Subscription } from 'rxjs';

@Component({
	selector: 'kpa-loader',
	templateUrl: './kpa-loader.component.html',
	styleUrls: ['./kpa-loader.component.scss'],
})
export class KpaLoaderComponent implements OnInit, OnDestroy {
	loading: boolean = false;
	private loadingSubscription: Subscription;

	constructor(
		private loadingIndicatorService: LoadingIndicatorService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.loadingSubscription = this.loadingIndicatorService.onLoadingChanged.subscribe((isLoading) => {
			this.loading = isLoading;
			this.cdr.detectChanges();
		});
	}

	ngOnDestroy() {
		if (this.loadingSubscription) {
			this.loadingSubscription.unsubscribe();
		}
	}
}
